export const DELIMITER = "|"; // Used to flatten arrays
